import { Grid } from "../../graph/lib/grid";

/**
 * Grid refinement for a tree.
 */
export class TreeGrid extends Grid {
    levelsVisible: boolean = false;


    getRootCoordinates(): [number, number] {
        let rootCoord: [number, number] = [1, this.cols / 2 ];
        return rootCoord;
    }

    draw(ctx: CanvasRenderingContext2D) {
        super.draw(ctx);
        if (this.levelsVisible)
            this.drawLevels(ctx);
    }

    setLevelsVisible(visible: boolean) {
        this.levelsVisible = visible;
    }

    private drawLevels(ctx: CanvasRenderingContext2D) {
        var i: number = 0;

        for (i = 0; i < this.rows; i++) {
            ctx.beginPath();
            ctx.moveTo(0, this.getHeightCell() * i);
            ctx.lineTo(this.getWidthCanvas(), this.getHeightCell() * i);
            ctx.stroke();
            ctx.closePath();
        }
    }

    //Every second row is a level
    /*
    *row 0   Level 0, root
    *row 1   Edge reserved
    *row 2   Level 1
    *row 3   Edge reserved
    *row 4   Level 2
    * ...
    * ...
    */

    /**
     * 
     * @param yRaw, raw y coordinate on the canvas.
     * @returns level of the clicked coordinate. If its a row reserved for edge, returns null
     */
    getLevel(yRaw: number): number {
        let lev = this.getCellCoordinates(0, yRaw)[1];
        return (lev % 2 == 0 ? lev / 2 : null)
    }

    getCanvasHeight(): number {
        return  this.canvas.clientWidth/1.5;
    }





}
